import { Route, Routes, Navigate, useLocation } from 'react-router-dom';
import Layout from './components/layout/Layout';
import { PrivateRoute } from './components/auth/PrivateRoute';
import { AuthProvider } from './hooks/useAuth';
import { LocalizationProvider } from './hooks/useLocalization';
import Dashboard from './pages/Dashboard';
import OrdensServico from './pages/OrdensServico';
import Agenda from './pages/Agenda';
import Clientes from './pages/Clientes';
import DetalhesCliente from './pages/DetalhesCliente';
import NovoCliente from './pages/NovoCliente';
import Veiculos from './pages/Veiculos';
import Estoque from './pages/Estoque';
import Servicos from './pages/Servicos';
import Financeiro from './pages/Financeiro';
import Equipe from './pages/Equipe';
import Configuracoes from './pages/Configuracoes';
import Sobre from './pages/Sobre';
import Planos from './pages/Planos';
import Pagamento from './pages/Pagamento';
import PainelGDN from './pages/PainelGDN';
import Login from './pages/Login';
import LandingPage from './pages/LandingPage';
import TrialSignup from './pages/TrialSignup';
import PartnerSignup from './pages/PartnerSignup';
import AgendamentoOnline from './pages/AgendamentoOnline';
import DetalhesOS from './pages/DetalhesOS';
import NovaOS from './pages/NovaOS';
import PublicQuote from './pages/PublicQuote';
import CustomerPortal from './pages/CustomerPortal';
import Perfil from './pages/Perfil';

const SYSTEM_HOSTS = ['sistema.mecsync.com.br', 'app.mecsync.com.br'];

function isSystemHost() {
  if (typeof window === 'undefined') return false;
  return SYSTEM_HOSTS.includes(window.location.hostname);
}

function AppRoutes() {
  const location = useLocation();
  const isLandingHome = location.pathname === '/' && !isSystemHost();

  if (isLandingHome) return <LandingPage />;

  return (
    <Routes>
      <Route path="/" element={<Navigate to="/login" replace />} />
      <Route path="/login" element={<Login />} />
      <Route path="/teste-gratis" element={<TrialSignup />} />
      <Route path="/oferta/:token" element={<TrialSignup />} />
      <Route path="/parceiros" element={<PartnerSignup />} />
      <Route path="/agendar/:slug" element={<AgendamentoOnline />} />
      <Route path="/orcamento/:token" element={<PublicQuote />} />
      <Route path="/portal" element={<CustomerPortal />} />
      <Route path="/dashboard" element={
        <PrivateRoute><Layout><Dashboard /></Layout></PrivateRoute>
      } />
      <Route path="/clientes" element={
        <PrivateRoute><Layout><Clientes /></Layout></PrivateRoute>
      } />
      <Route path="/clientes/:id" element={
        <PrivateRoute><Layout><DetalhesCliente /></Layout></PrivateRoute>
      } />
      <Route path="/novo-cliente" element={
        <PrivateRoute><Layout><NovoCliente /></Layout></PrivateRoute>
      } />
      <Route path="/veiculos" element={
        <PrivateRoute><Layout><Veiculos /></Layout></PrivateRoute>
      } />
      <Route path="/ordens-servico" element={
        <PrivateRoute><Layout><OrdensServico /></Layout></PrivateRoute>
      } />
      <Route path="/ordens/nova" element={
        <PrivateRoute><Layout><NovaOS /></Layout></PrivateRoute>
      } />
      <Route path="/ordens/:id" element={
        <PrivateRoute><Layout><DetalhesOS /></Layout></PrivateRoute>
      } />
      <Route path="/ordens/:id/edit" element={
        <PrivateRoute><Layout><DetalhesOS /></Layout></PrivateRoute>
      } />
      <Route path="/estoque" element={
        <PrivateRoute allowedProfiles={['admin']}><Layout><Estoque /></Layout></PrivateRoute>
      } />
      <Route path="/servicos" element={
        <PrivateRoute allowedProfiles={['admin', 'mecanico']}><Layout><Servicos /></Layout></PrivateRoute>
      } />
      <Route path="/financeiro" element={
        <PrivateRoute allowedProfiles={['admin']}><Layout><Financeiro /></Layout></PrivateRoute>
      } />
      <Route path="/agenda" element={
        <PrivateRoute allowedProfiles={['admin', 'mecanico', 'super_admin', 'gdn_admin']}><Layout><Agenda /></Layout></PrivateRoute>
      } />
      <Route path="/equipe" element={
        <PrivateRoute allowedProfiles={['admin']}><Layout><Equipe /></Layout></PrivateRoute>
      } />
      <Route path="/configuracoes" element={
        <PrivateRoute allowedProfiles={['admin']}><Layout><Configuracoes /></Layout></PrivateRoute>
      } />
      <Route path="/configuracoes/sobre" element={
        <PrivateRoute allowedProfiles={['admin']}><Layout><Sobre /></Layout></PrivateRoute>
      } />
      <Route path="/configuracoes/planos" element={
        <PrivateRoute allowedProfiles={['admin']}><Layout><Planos /></Layout></PrivateRoute>
      } />
      <Route path="/configuracoes/pagamento" element={
        <PrivateRoute allowedProfiles={['admin', 'super_admin', 'gdn_admin']} skipBillingCheck><Layout><Pagamento /></Layout></PrivateRoute>
      } />
      <Route path="/configuracoes/contrato" element={<Navigate to="/configuracoes" replace />} />
      <Route path="/perfil" element={
        <PrivateRoute><Layout><Perfil /></Layout></PrivateRoute>
      } />
      <Route path="/gdn" element={<Navigate to="/gdn/clientes" replace />} />
      <Route path="/gdn/clientes" element={
        <PrivateRoute allowedProfiles={['super_admin', 'gdn_admin']} skipBillingCheck><Layout variant="gdn"><PainelGDN /></Layout></PrivateRoute>
      } />
      <Route path="/gdn/planos" element={
        <PrivateRoute allowedProfiles={['super_admin', 'gdn_admin']} skipBillingCheck><Layout variant="gdn"><Planos /></Layout></PrivateRoute>
      } />
      <Route path="/gdn-admin" element={
        <PrivateRoute allowedProfiles={['super_admin']} skipBillingCheck><Layout variant="gdn"><PainelGDN /></Layout></PrivateRoute>
      } />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <LocalizationProvider>
        <AppRoutes />
      </LocalizationProvider>
    </AuthProvider>
  );
}
